var React = require('react');

function IconLinkedin (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"13","cy":"13","r":"13","fill":"#EB5757","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 17.337v-9.34C6 6.894 6.894 6 7.997 6h9.34c1.102 0 1.996.894 1.996 1.997v9.34a1.996 1.996 0 01-1.996 1.996h-9.34A1.996 1.996 0 016 17.337zM7.997 7.333a.663.663 0 00-.664.664v9.34c0 .366.297.663.664.663h9.34a.663.663 0 00.663-.663v-9.34a.663.663 0 00-.663-.664h-9.34zm2.003 4c-.37 0-.667.3-.667.669v3.33a.667.667 0 101.334 0v-3.33a.668.668 0 00-.667-.669zm0-.666a.667.667 0 110-1.334.667.667 0 010 1.334zm3 4.666V13.5a.834.834 0 011.667 0v1.833a.667.667 0 101.333 0V13.5a2.168 2.168 0 00-4.333 0v1.833a.667.667 0 101.333 0z","fill":"#fff","key":1})]);
}

IconLinkedin.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = IconLinkedin;

IconLinkedin.default = IconLinkedin;
